// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'building-3-solid';

export const Component = () => (
  <path d='M22.116 23.516H20.63V1.486c0-.432-.143-.767-.431-1.055A1.408 1.408 0 0 0 19.146 0H5.448c-.43 0-.766.144-1.053.431a1.408 1.408 0 0 0-.432 1.054v22.03H2.48c-.335 0-.479.192-.479.527s.144.48.479.48h19.636c.335 0 .479-.145.479-.48 0-.335-.144-.526-.48-.526h.002Zm-6.37-6.85v6.849H8.847v-6.849c0-.239.097-.479.288-.67a.976.976 0 0 1 .719-.287h4.885a.98.98 0 0 1 .719.287.943.943 0 0 1 .287.67Zm.957-6.37v1.964c0 .335-.144.48-.479.48H8.37c-.336 0-.48-.145-.48-.48v-1.963c0-.335.144-.479.48-.479h7.854c.335 0 .48.144.48.479Zm0-5.89V6.37c0 .335-.144.478-.479.478H8.37c-.336 0-.48-.143-.48-.478V4.406c0-.335.144-.479.48-.479h7.854c.335 0 .48.144.48.48Z' />
);

export const viewBox = '0 0 25 25';
